import { useCallback, useEffect, useMemo, useState } from "react";
import MaterialReactTable from 'material-react-table';
import axios from "axios";
import { BASE_URL } from "ApplicationURI";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField,  Typography } from "@mui/material";
import { Form } from "react-bootstrap";
import { request } from "components/axiosconfig";
import { Delete } from "@mui/icons-material";
import { GET_MAINFEATURE_DETAILS } from "ApplicationURI";
import { ADD_MAINFEATURE } from "ApplicationURI";
import { useForm, Controller } from 'react-hook-form';
import { EDIT_MAINFEATURE } from "ApplicationURI";
import { DELETE_MAINFEATURE } from "ApplicationURI";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

     
function MainFeature() {
  const [response,setResponse] = useState([])
  const [open, setOpen] = useState(false);

  const { control, handleSubmit,reset, formState: { errors }} = useForm( );
  const [errorMessage, setErrorMessage] = useState('');
const [openSnackbar, setOpenSnackbar] = useState(false);
const [isButtonDisabled, setButtonDisabled] = useState(true);







  const handleAddSubmit=(data)=>{
    console.log("this is adddddddd");
    // e.preventDefault();
    const postData = {
      title: data.title.trim().replace(/\s{2,}/g, ' '), 
      icon: data.icon.trim().replace(/\s{2,}/g, ' '),
    };
    
    console.log("thiss is adddd data"+JSON.stringify(data) );

    request({url:ADD_MAINFEATURE, method:"post", data:postData }).then(res=>{
      console.log(res);
      if(res.status===200){
      handleAddClose();
      MainFeatureList();
      reset();

          }
    }).catch(error=>{
      console.log(error.response); // Log the error response object
      if (error.response) {
        // Request was made and server responded with a status code
        console.log("error.response.status" + error.response.status);
        console.log("fhgfhgf" + error.response.data.message);

        if (error.response.status !== 200 || error.response.status !== 201) {
          setErrorMessage(error.response.data.message);
          setOpenSnackbar(true);
        }
      } else if (error.request) {
        
        console.log(error.request);
      } else {
      
        console.log('Error', error.message);
      }
    });
  }

  const handleSaveRow = ({ row, values, exitEditingMode }) => { 
    const fieldDisplayNames = {
      title: 'Topic',
      icon: 'Icon', // You can add more fields here as needed
    };
  
    const requiredFields = ['title', 'icon'];
    const validationMessages = requiredFields.reduce((messages, field) => {
      const value = values[field];
      const displayName = fieldDisplayNames[field];
  
      // Check if the field is empty or contains only whitespace
      const trimmedValue = value.trim();

      // Check if the field is empty after trimming
      if (!trimmedValue) {
        messages.push(`${displayName} is required.`);
      } else {
        // Check if the field has less than 2 characters or more than 30 characters after trimming
        if (trimmedValue.length < 2) {
          messages.push(`${displayName} should be a minimum of 2 characters.`);
        } else if (trimmedValue.length > 30) {
          messages.push(`${displayName} cannot exceed 30 characters.`);
        }
      }
  
      return messages;
    }, []);
  
    if (validationMessages.length > 0) {
      alert(`Please correct the following issues:\n${validationMessages.join('\n')}`);
      return;
    }
  
    console.log("aishuuuuuuuuuuu testtttttttt" + row.original.id);
    console.log(values);
  
    if (!values) {
      return;
    }
  
    const data = {
      title: values.title.trim().replace(/\s{2,}/g, ' '),
      icon: values.icon.trim().replace(/\s{2,}/g, ' '), 
    };
  
    request({ url: `${EDIT_MAINFEATURE}${row.original.id}`, method: "put", data: data })
      .then((res) => {
        const updatedData = [...response];
        updatedData[row.index] = res.data;
        setResponse(updatedData);
        console.log(updatedData + "updated data");
        exitEditingMode();
      })
      .catch((error) => {
        console.log(error);
      });
  };
  
  function handleDelete(data) {
    const isConfirmed = window.confirm('Are you sure you want to delete this Feature Category?');
  
    if (isConfirmed) {
      console.log(data.original.id);
      // console.log("this is delete inside");
  
      request({ url: `${DELETE_MAINFEATURE}${data.original.id}`, method: "delete" })
        .then(res => {
          // console.log(res);
          MainFeatureList();
        })
        .catch(error => {
          console.log(error);
        });
    } else {
      // console.log('Deletion canceled.');
    }
  }
  

    const handleClickOpen = () => {
      setOpen(true);
        
    };
    
    const handleClose = () => {
      setOpen(false);
      
    
    };
    const handleSnackbarClose = () => {
      setOpenSnackbar(false);
    };
    
    const handleAddClose =()=>{
      setOpen(false);
      reset();
    }

    const MainFeatureList = useCallback(() => {
  axios.get(BASE_URL + GET_MAINFEATURE_DETAILS)
    .then((res) => {
      setResponse(res.data);
      if (res.data.length < 4) {
        setButtonDisabled(false);
      } else {
        setButtonDisabled(true);
      }
    })
    .catch((e) => console.log(e));
}, []);

useEffect(() => {
  MainFeatureList();
}, [MainFeatureList]);

  
    const columns = useMemo(
      (rowData) => [
        {
          accessorKey:'id',
          header:'Id',
          enableHiding:false
        },
        {
          accessorKey: 'title',
          header: 'Topic',
          accessorFn:(row)=>row?row.title:''
        
        },
        {
          accessorKey:'icon',
          header: 'Icon',
          accessorFn:(row)=>row?row.icon:''
          // accessorFn: (row) => row.username,
        },
       
      
        ],
      []
    );
    return (
      
      <div className="mt-3">
      <Button variant="contained"  style={{float:'left',marginTop:20,marginLeft:20}} 
      onClick={handleClickOpen} disabled={isButtonDisabled} >
     Add
   </Button>

   <Snackbar
  open={openSnackbar}
  autoHideDuration={6000}
  onClose={handleSnackbarClose}
  anchorOrigin={{
    vertical: 'top',
    horizontal: 'center'
  }}
  style={{width:"100%"}}
>
      <MuiAlert severity="error" onClose={handleSnackbarClose} style={{ width: '50%' }}>
        {errorMessage}
      </MuiAlert>
    </Snackbar>
   <Dialog open={open} onClose={handleClose} aria-labelledby="draggable-dialog-title"   fullWidth
maxWidth="md">
     <DialogTitle id="draggable-dialog-title">ADD</DialogTitle>
     <DialogContent>
     <Form onSubmit={handleSubmit(handleAddSubmit)}>
         <Form.Group>
         <Controller
  name="title"
  control={control}
  defaultValue=""
  rules={{
    required: { value: true, message: 'Topic is required' },
    validate: {
      minLength: value => value.trim().length >= 2 || 'Please provide a minimum of 2 characters.',
      maxLength: value => value.trim().length <= 30 || 'Topic cannot exceed 30 characters.',
      noWhitespace: value => value.trim() !== '' || 'Topic is required',
    },
  }}
  render={({ field }) => (
    <TextField
      fullWidth
      {...field}
      label="Topic"
      margin='dense'
      error={Boolean(errors?.title?.message)}
      helperText={errors?.title?.message}
    />
  )}
/>



         </Form.Group>

        
     
         <Form.Group>
         <Controller
  name="icon"
  control={control}
  defaultValue=""
  rules={{
    required: { value: true, message: 'Icon is required' },
    validate: {
      minLength: value => value.trim().length >= 2 || 'Please provide a minimum of 2 characters.',
      maxLength: value => value.trim().length <= 30 || 'Icon cannot exceed 30 characters.',
      noWhitespace: value => value.trim() !== '' || 'Icon is required',
    },
  }}
  // validate={value => value.trim()}
  render={({ field }) => (
    <TextField
      fullWidth
      {...field}     
      label="Icon"
      margin='dense'
      error={Boolean(errors?.icon?.message)}
      helperText={errors?.icon?.message}
     
    />
  )}
/>
         </Form.Group>
         <DialogActions>
     <Button onClick={handleAddClose}>Cancel</Button>
 <Button type="submit" color="primary">
   Submit
 </Button>
     </DialogActions>
       </Form>

     </DialogContent>
   
   </Dialog>
        <MaterialReactTable 
   columns={columns} 
   data={response}
   editingMode="row"
   enableEditing
   initialState={{ columnVisibility: { id: false } }}
   enableRowActions
   enableColumnFilters={false}

   onEditingRowSave={handleSaveRow}

   renderRowActionMenuItems={({ row }) => [
    
 
      <IconButton color="error" onClick={() => handleDelete(row)} >
        <Delete />  &nbsp;&nbsp;&nbsp;<Typography> Delete</Typography>
       </IconButton>
   
   ]}
   
   />

    
   </div>
    );
  };
export default MainFeature